import PropTypes from "prop-types";
import classnames from "classnames";
import { withTranslation } from "@template/components/translation";
import deferredStyles from "../NativeAppBanner/deferred.css";
import styles from "./index.css";

const AppRating = ({ formatTranslation, darkStars, showCount }) => (
  <>
    <span
      className={classnames(deferredStyles.starsContainer, {
        [deferredStyles.darkStars]: darkStars
      })}
      role="img"
      aria-label={formatTranslation("app_download_rating")}
    />
    {showCount && (
      <span className={styles.ratingSpan} aria-hidden="true">
        {formatTranslation("app_download_count")}
      </span>
    )}
  </>
);

AppRating.propTypes = {
  formatTranslation: PropTypes.func.isRequired,
  darkStars: PropTypes.bool,
  showCount: PropTypes.bool
};

export default withTranslation(AppRating);
